<ion-header>
  <ion-toolbar>
    <ion-title> {{ 'Select teams' | translate }}</ion-title>
    <ion-buttons slot="end">
      <app-close-button></app-close-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list class="content-width">
    <ion-item *ngFor="let team of teams; let i = index">
      <ion-checkbox
        color="secondary"
        labelPlacement="end"
        justify="start"
        (ionChange)="selectTeam($event, i)"
      >
        <div class="team-item">
          @if(team?.profile_image){
          <img class="team-photo" [src]="team?.profile_image" alt="" />
          } @else if (team?.logo && team?.logo.length > 0) {
          <img class="team-photo" [src]="team?.logo" alt="" />
          } @else {
          <div
            class="team-avatar"
            [ngStyle]="{ backgroundColor: ths.getTeamColor(team) }"
          >
            {{
              team?.abbreviation
                ? team?.abbreviation?.slice(0, 2)
                : ths.getTeamInitials(team)
            }}
          </div>
          }

          {{ team.name }}
        </div>
      </ion-checkbox>
    </ion-item>
  </ion-list>

  <div
    [hidden]="!isLoading"
    class="content-width ion-margin"
    *ngFor="let item of [0, 1, 2, 3, 4]"
  >
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button
      [disabled]="!selectedTeams.length"
      class="ion-margin-start ion-margin-end"
      (click)="selectTeams()"
      expand="block"
      fill="solid"
    >
      {{'Select teams' | translate}}
    </ion-button>
  </ion-toolbar>
</ion-footer>
